import { Button, Modal, ModalProps } from "react-bootstrap";
import { Variant } from "react-bootstrap/esm/types";

type Props = {
  isVisible: boolean;
  question: string;
  cancelText?: string;
  submitText?: string;
  submitVariant?: Variant;
  size?: ModalProps["size"];
  body?: JSX.Element;
  onHide: () => void;
  onSubmit: () => void;
};

const ConfirmModal = ({
  isVisible,
  question,
  submitText,
  submitVariant,
  cancelText,
  size,
  body,
  onHide,
  onSubmit,
}: Props) => {
  return (
    <Modal show={isVisible} onHide={onHide} size={size} backdrop="static">
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>{question}</Modal.Title>
      </Modal.Header>
      {body && <Modal.Body>{body}</Modal.Body>}
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {cancelText || "Cancel"}
        </Button>
        <Button variant={submitVariant || "primary"} onClick={onSubmit}>
          {submitText || "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
